// extracted by mini-css-extract-plugin
export default {"deck":"Deck_deck__3WmfT"};